export const ADDTOCART = 'addtocart';
export const BRAND = 'Sunrise';
export const CURRENCY = 'CHF';
export const STICKYLINETABLE = 'Sticky Line Table';
export const SELECTPROMOTION = 'select_promotion';
export const VIEWPROMOTION = 'view_promotion';
export const VIEWOPTIONPOPUP = 'view_option_popup';
export const CLOSEOPTIONPOPUP = 'close_option_popup';
export const CTABUTTONCLICK = 'cta_button_click';
export const CTATEXTCLICK = 'cta_text_click';
export const DOWNLOADPRODUCT = 'download_product_details';
export const ADDOPTIONTOCART = 'add_option_to_cart';
export const BUNDLEPRODUCT = 'BUNDLE';
export const GAEVENT = 'gaEvent';
export const STAGETEASER = 'Stage Teaser';
export const LINETABLE = 'Line Table';
export const LINETABLEPRODUCT = 'Line Table - Product';
export const LINETABLEDEVICE = 'Line Table - Device';
export const COMBINEDEVICE = 'combine_with_device';
export const TABCLICK = 'tab_click';
export const TOGGLE_ON_CONFIGURATOR = 'toggle_on_configurator';
export const TOGGLE_OFF_CONFIGURATOR = 'toggle_off_configurator';
export const MOBILEORDER = 'MOBILE_ORDER';
export const HOMEORDER = 'HOME_ORDER';
export const MOBILESUBSCRIPTION = 'Mobile Subscription Only';
export const INTERNETSUBSCRIPTION = 'Internet Subscription Only';
export const CMS = 'CMS';
export const ALL = 'All';
export const POPUPPROMO = 'promotion_popup';

export const TYPE = 'click';
export const SBLINECHECKSTART = 'line_check_start';
export const SBLINECHECKRESULT = 'line_check_results';
export const SBLINECHECKCHANGE = 'line_check_change';
export const SBLINECHECKEXIT = 'line_check_exit';
export const LINETABLERESULT = 'lineCheckResult';
export const VIEW = 'view';
export const LINECHECKSTART = 'lineCheckStart';
export const CHECKADDRESS = 'Check address';
export const LINEADDRESS = 'lineTableView Address';
export const CHANGE = 'Change';
export const ERRORMESSAGE = 'Missing or Invalid Error';
export const ERRORTYPE = 'error';
export const FIXNET = 'fixnet';
export const AUTHCOOKIE = 'sunriseAuth';
export const ERROR = 'error';
export const LOGIN = 'login';
export const LOGINSUCCESSFUL = 'loginSuccessful';
export const PASSWORD = 'Password';
export const PASSWORDSUCCESSFUL = 'success via password';
export const REMMSELECTED = 'Remember me | Selected';
export const REMMNOTSELECTED = 'Remember me | not selected';
export const PASSWORDUNSUCCESSFUL = 'unSuccess via password';
export const LOGINERROR = 'LoginError';
export const SUCCESSFULL = 'successful';
export const LOGINUNSUCCESSFUL = 'loginUnSuccessful';
export const FAILED = 'failed';
export const GETTEMPCODE = 'get_temporary_code';
export const LOGINUSERVERIFIED = 'userVerified';
export const SUCCESSFUL = 'success';
export const LOGINUSERNOTVERIFIED = 'userNotVerified';
export const UNSUCCESSFUL = 'unSuccess';
export const OTP = 'Enter the temporary code';
export const CHANNELSELECTION = 'Get a temporary code via SMS/Email';
export const VIA = 'via';
export const SENDOTP = 'send_otp';
export const OTPLOGINSUCCESS = 'otp_login_success';
export const OTPLOGINFAIL = 'otp_login_fail';
export const VEIW = 'view';
export const MTAN = 'MTAN';
export const LOGINNEXT = 'Next';
export const TEMPCODENEXT = 'Login Get a temporary code';

export const EXISTINGCUSTOMER = 'existing-customer';
export const NEWCUSTOMER = 'new-customer';
export const DEFAULT = 'default';
export const SUNRISEINTERNET = 'Internet';
export const SUNRISEMOBILE = 'Mobile';
export const SUNRISEBOTHSUBSCRIPTION = 'Mobile,Internet';
export const POSTPAID = 'POSTPAID';
export const CAPSINTERNET = 'INTERNET';
//herobanner
export const HEROBANNER = 'HeroBanner';
export const STICKYBOTTOMSHEET = 'StickyBottomSheet';

//US_31295
export const TOGGLECLICK = 'toggle_click';

//US 349849
export const ACCESSORYCATEGORY = 'Accessory';
export const ACCESSORYLISTNAME = 'Device Accessories';
export const VIEWITEM = 'view_item_list';
export const REMOVEOPTIONFROMCART = 'remove_option_from_cart';
export const VIEWEACHITEM = 'view_item';
export const REMOVEFROMCART = 'remove_from_cart';
export const ADD_TO_CART = 'add_to_cart';
export const APPLYFILTER = 'apply_filter';
export const CONTENT = 'content';
export const TEXT = 'text';
export const TABLE = 'Table';
export const GENERATELEAD = 'generate_lead';
export const HARDWARE = 'Hardware';
export const LINK = 'Link';
export const CONTINUE = 'Continue';
export const LEARNMORE = 'Learn more';
export const CLOSEPOPUP ='close_popup';
export const POPUP = 'popup';
export const INFO = 'Info';
export const REPLACE = 'Replace';
export const KEEPPREVIOUS = 'Keep previous';
export const REPLACESELECTION = 'Replace selection';
export const OPENPOPUP = 'open_popup';
export const ACCORDIONCLICK = 'accordion_click';
export const FORM = 'form';
export const OPEN = 'open';
export const CLOSE = 'close';
